import { DeliveryListApp } from './DeliveryListApp';
import { get, writable } from 'svelte/store';
import { api } from '../../../../../stores/api';

export let dla = writable<DeliveryListApp>(new DeliveryListApp());

get(dla).setApi(get(api));
